import reframe from 'reframe.js/dist/reframe.es';

// Make sure videos keep their aspect ratio
reframe('iframe:not(.no-reframe)');
